import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from 'element-ui';
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    children: [
      {
        path: '/companyWrite',
        name: 'companyWrite',
        component: () => import('@/views/companyWrite/companyWrite.vue')
      },
      {
        path: '/outlinkWrite',
        name: 'outlinkWrite',
        component: () => import('@/views/outlinkWrite/outlinkWrite.vue')
      },
      {
        path: '/drafts',
        name: 'drafts',
        component: () => import('@/views/drafts/drafts.vue')
      },
      {
        path: '/workReview',
        name: 'workReview',
        component: () => import('@/views/workReview/workReview.vue')
      },
      {
        path: '/workRecommend',
        name: 'workRecommend',
        component: () => import('@/views/workRecommend/workRecommend.vue'),
        meta: {
          path: '/workRecommend'
        }
      },
      {
        path: '/workRecommendNext',
        name: 'workRecommendNext',
        component: () => import('@/views/workRecommendNext/workRecommendNext.vue'),
        meta: {
          path: '/workRecommendNext'
        }
      },
      {
        path: '/setting',
        name: 'setting',
        component: () => import('@/views/Setting/Setting.vue')
      }
    ]
  },
  {
    path: '/share/login',
    name: 'shareLogin',
    component: () => import('@/views/share/Login.vue')
  },
  {
    path: '/share/chooseType',
    name: 'shareChooseType',
    component: () => import('@/views/share/ChooseType.vue')
  },
  {
    path: '/share/writePage',
    name: 'shareWritePage',
    component: () => import('@/views/share/WritePage.vue')
  },
  {
    path: '/share/finishWrite',
    name: 'shareFinishWrite',
    component: () => import('@/views/share/FinishWrite.vue')
  },
  {
    path: '/share/peoplelogin',
    name: 'peopleLogin',
    component: () => import('@/views/PeopleIn/PeopleLogin.vue')
  },
  {
    path: '/shareself/login',
    name: 'shareselfLogin',
    component: () => import('@/views/shareself/Login.vue')
  },
  {
    path: '/shareself/chooseType',
    name: 'shareselfChooseType',
    component: () => import('@/views/shareself/ChooseType.vue')
  },
  {
    path: '/shareself/writePage',
    name: 'shareselfWritePage',
    component: () => import('@/views/shareself/WritePage.vue')
  },
  {
    path: '/shareself/finishWrite',
    name: 'shareselfFinishWrite',
    component: () => import('@/views/shareself/FinishWrite.vue')
  },
  {
    path: '/menuconfig',
    name: 'config',
    component: () => import('@/views/config/Config.vue')
  }
]

const router = new VueRouter({
  routes
})
// 无需令牌白名单
const whiteList = [];

router.beforeEach(async (to, from, next) => {

  // 访问⽩名单⻚⾯：放⾏
  if (whiteList.includes(to.path) || to.path.startsWith('/share/') || to.path.startsWith('/shareself/')) {
  // if (whiteList.includes(to.path)) {

    next();
  } else {
    // 获取令牌判断用户是否登录
    const hasToken = localStorage.getItem("token");
    // 判断是否需要登录权限
    if (!hasToken) {
      if (to.path === '/') {
        next()
      } else {
        Message.error("登录失效，请重新登录");
        // Message.error("报送已结束，系统已关闭");
        next('/'); // 如果未登录，跳转到登录页面
      }
    } else {
      const user = JSON.parse(localStorage.getItem("user"));
      const validAccounts = ['root', '17829752132', '17829752113'];
      if (user && validAccounts.includes(user.account)) {
        next();
      } else {
        if (to.path === '/') {
          next();
        } else {
          // Message.warning("报送已结束，系统已关闭");
          // next('/');
          next();
        }
      }
    }
  }

});

export default router
